import Tabs, { Tab } from "Components/Atoms/Tabs";
import { useCallback, useMemo } from "react";
import { TextElement } from "types/types";
import Section from "../Atoms/TextSection";

type Props = {
  guide: TextElement[];
  example: TextElement[];
  addTerm: (value: any) => void;
  visible?: boolean;
};

/**
   @function GuideExample
   render guide and example
   @param guide {array}: guide to render
   @param example {array}: example guide to render
   @param addTerm {fucntion}: function to add Terms
*/
export default function GuideExample({
  guide,
  example,
  addTerm = () => {},
  visible = true,
}: Props) {
  const renderContent = (elements: TextElement[], id: string) => (
    <div className="mt-8 h-[63vh] overflow-y-auto pr-6" id="guide-example-text">
      {elements.map((element: TextElement, index) => {
        return (
          <Section
            text={element}
            key={`tab-${id}-element-${index}`}
            setTerms={(id) => addTerm(id)}
          />
        );
      })}
    </div>
  );

  const createTab = useCallback(
    (id: string, label: string, content: TextElement[]): Tab => ({
      id,
      label,
      content: renderContent(content, id),
    }),
    []
  );

  const guideTab = useMemo(
    () => (guide.length > 0 ? [createTab("guide", "Guides", guide)] : []),
    [createTab, guide]
  );
  const exampleTab = useMemo(
    () =>
      example.length > 0 ? [createTab("example", "Examples", example)] : [],
    [createTab, example]
  );

  const tabs = useMemo(
    () => [...guideTab, ...exampleTab],
    [guideTab, exampleTab]
  );

  return <Tabs tabs={tabs} className={visible ? "" : "hidden"} />;
}
